module.exports = __webpack_public_path__ + "static/media/Mulish-Bold.c82f38f6.eot";